/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentOwnerProfile,
  AgentOwnerProfile$inboundSchema,
} from "./agentownerprofile.js";
import {
  AgentPermissions,
  AgentPermissions$inboundSchema,
} from "./agentpermissions.js";

export const Lifecycle = {
  Active: "active",
  Suspended: "suspended",
  Revoked: "revoked",
} as const;
export type Lifecycle = OpenEnum<typeof Lifecycle>;

export type ManagedAgent = {
  createdAt: Date;
  id: string;
  lifecycle: Lifecycle;
  name: string;
  ownerProfile?: AgentOwnerProfile | undefined;
  /**
   * Stable reason that explicit reassignment is required
   */
  ownerReassignmentReason?: string | undefined;
  /**
   * When owner loss durably blocked this agent
   */
  ownerReassignmentRequiredAt?: Date | undefined;
  ownerUserId: string;
  permissions: AgentPermissions;
  /**
   * The optional project this agent is scoped to; absent for an organization-wide agent
   */
  projectId?: string | undefined;
  updatedAt: Date;
};

/** @internal */
export const Lifecycle$inboundSchema: z.ZodMiniType<Lifecycle, unknown> =
  openEnums.inboundSchema(Lifecycle);

/** @internal */
export const ManagedAgent$inboundSchema: z.ZodMiniType<ManagedAgent, unknown> =
  z.pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      id: z.string(),
      lifecycle: Lifecycle$inboundSchema,
      name: z.string(),
      owner_profile: z.optional(AgentOwnerProfile$inboundSchema),
      owner_reassignment_reason: z.optional(z.string()),
      owner_reassignment_required_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
      owner_user_id: z.string(),
      permissions: AgentPermissions$inboundSchema,
      project_id: z.optional(z.string()),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "owner_profile": "ownerProfile",
        "owner_reassignment_reason": "ownerReassignmentReason",
        "owner_reassignment_required_at": "ownerReassignmentRequiredAt",
        "owner_user_id": "ownerUserId",
        "project_id": "projectId",
        "updated_at": "updatedAt",
      });
    }),
  );

export function managedAgentFromJSON(
  jsonString: string,
): SafeParseResult<ManagedAgent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManagedAgent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManagedAgent' from JSON`,
  );
}
